export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const SOURCE_HOME = 'SOURCE_HOME';
export const SOURCE_WEBVIEW = 'SOURCE_WEBVIEW';
